import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../_metronic/layout";
import { AttendanceList } from "./Attendance/AttendanceList";
import { BadgePrintList } from "./BadgePrint/BadgePrintList";
import { CompetitionVisitsList } from "./Competitions/CompetitionVisitsList";
import { CheckInContextProvider } from "./Components/CheckInDataContext";

/**
 * Check-in — staff tools for the attendance kiosk.
 *
 * Three screens over the same branch: print the badges students scan, read back
 * what those scans (and the coaches' registers) recorded for a day's classes,
 * and see who was in the building for a competition.
 *
 * All three read the branch from `auth.branches.currentBranch` by way of
 * CheckInContextProvider — the subheader picker, shared with the rest of the
 * portal. There is deliberately no branch selector of Check-in's own.
 *
 * The tab strip is not rendered here. `nav-tabs-line` is card furniture — it is
 * drawn for the inside of a white Metronic card, below its header, exactly as
 * `Batches/Classes/BatchEdit.js` draws it. Rendered at this level it landed on
 * the page's blue subheader gradient instead, where pale grey tabs and a thin
 * active underline are all but unreadable. So each of the three screens renders
 * `<CheckInTabs />` itself, as the first thing in its own `card-body`.
 *
 * That is three one-line renders instead of one, and remounting a strip of
 * three links between tabs costs nothing — cheaper than threading a card shell
 * through the router to keep a single copy.
 */
export default function CheckInPage() {
  return (
    <CheckInContextProvider>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <Redirect exact={true} from="/check-in" to="/check-in/badges" />

          <ContentRoute path="/check-in/badges" component={BadgePrintList} />
          <ContentRoute
            path="/check-in/attendance"
            component={AttendanceList}
          />
          <ContentRoute
            path="/check-in/competitions"
            component={CompetitionVisitsList}
          />
        </Switch>
      </Suspense>
    </CheckInContextProvider>
  );
}
